
module.config(function($provide, moment) {
    $provide.decorator('dateFilter', function($delegate) {
        return function(date, format, timezone) {
            if (moment.isMoment(date)) {
                return date.format(format || 'LL');
            } else {
                return $delegate(date, format, timezone);
            }
        };
    });
});


module.filter('momentConvert', function(moment) {

    function parseDates(value) {
        var key, i, date;
        if (angular.isString(value)) {
            date = moment.utc(value, ['YYYY-MM-DD', moment.ISO_8601], true);
            if (date.isValid()) {
                return date.parsingFlags().iso ? date.local() : date;
            }
            return value;
        } else if (angular.isObject(value)) {
            for (key in value) {
                value[key] = parseDates(value[key]);
            }
            return value;
        } else if (angular.isArray(value)) {
            for (i = 0; i < value.length; i++) {
                value[i] = parseDates(value[i]);
            }
        } else {
            return value;
        }
    }

    return parseDates;
});


module.filter('momentCalendar', function(moment) {
    return function(date, reference) {
        if (!moment.isMoment(date)) {
            date = moment.utc(date);
            date.local();
        }
        return date.calendar(reference);
    };
});


module.filter('momentFrom', function(moment) {
    return function(date, reference) {
        if (!moment.isMoment(date)) {
            date = moment.utc(date);
            date.local();
        }
        return date.from(reference, true);
    };
});

module.filter('dateDiff', function() {
    return function(date, otherDate, units) {
        units = units || 'days';
        return otherDate.diff(date, units);
    };
});


module.filter('ago', function(moment) {
    return function(date, ago) {
        if (moment.isMoment(date)) {
            return date.fromNow(!ago);
        }
    }
});


module.filter('inFuture', function(moment) {
    return function(date) {
        if (moment.isMoment(date)) {
            return date > moment();
        }
        return false;
    };
});


module.filter('momentAdd', function(moment) {
    return function(date, amt, unit) {
        if (moment.isMoment(date)) {
            return moment(date).add(amt, unit);
        }
        return date;
    }
})